import React, { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { PrincipalFormData, PrincipalFormErrors } from "../types";

interface WhitelistedIPsFormProps {
  formData: PrincipalFormData;
  formErrors: PrincipalFormErrors;
  onAddIp: (ip: string) => void;
  onRemoveIp: (index: number) => void;
}

const WhitelistedIPsForm: React.FC<WhitelistedIPsFormProps> = ({
  formData,
  formErrors,
  onAddIp,
  onRemoveIp,
}) => {
  const [newIp, setNewIp] = useState("");

  const handleAddIp = () => {
    if (newIp.trim() !== "") {
      onAddIp(newIp.trim());
      setNewIp("");
    }
  };

  return (
    <div className="bg-white rounded-xl p-6 flex flex-col justify-start min-h-[120px] transition-shadow duration-200 transition-colors border-[1px] border-cardborder">
      <h2 className="text-lg font-semibold mb-4">
        Whitelisted IPs
      </h2>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Add IP Address
          </label>
          <div className="border border-gray-300 rounded-lg p-4 bg-white">
            <div className="flex items-center gap-3 mb-3">
              <input
                type="text"
                value={newIp}
                onChange={(e) => setNewIp(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleAddIp();
                  }
                }}
                placeholder="Enter IP address (e.g., 192.168.1.1)"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md bg-white text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand"
              />
              <button
                type="button"
                onClick={handleAddIp}
                className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700 focus:outline-none focus:ring-1 focus:ring-green-500 flex items-center gap-2"
              >
                <Plus className="w-4 h-4" />
                Add IP
              </button>
            </div>
            {formData.whiteListedIps.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {formData.whiteListedIps.map((ip, index) => (
                  <span
                    key={index}
                    className="bg-gray-100 rounded-full px-3 py-1 text-sm flex items-center gap-2"
                  >
                    {ip}
                    <button
                      type="button"
                      onClick={() => onRemoveIp(index)}
                      className="text-red-500 hover:text-red-700 transition-colors"
                      title="Remove IP"
                    >
                      <Trash2 className="w-3 h-3" />
                    </button>
                  </span>
                ))}
              </div>
            )}
          </div>
          {formErrors.whiteListedIps && (
            <div className="text-red-500 text-sm mt-1">
              {formErrors.whiteListedIps}
            </div>
          )}
        </div>

        {formData.whiteListedIps.length === 0 && (
          <p className="text-sm text-gray-500">
            No whitelisted IPs added. Click "Add IP" to add IP addresses that are allowed to access this principal.
          </p>
        )}
      </div>
    </div>
  );
};

export default WhitelistedIPsForm;

